/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BreadcrumbsInputs */

const th_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณอยู่ที่นี่`)
};

const en_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are here`)
};

const ja_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在地`)
};

const zh_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你在这里`)
};

const es_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estás aquí`)
};

const pt_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você está aqui`)
};

const id_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda di sini`)
};

const fr_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous êtes ici`)
};

const tl_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narito ka`)
};

const vi_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn đang ở đây`)
};

const ko_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 위치`)
};

const de_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist hier`)
};

const ru_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы здесь`)
};

const tr_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buradasınız`)
};

const it_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei qui`)
};

const pl_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jesteś tutaj`)
};

const uk_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви тут`)
};

const hi_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप यहाँ हैं`)
};

const ar_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنت هنا`)
};

const ms_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda di sini`)
};

const bn_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি এখানে`)
};

const zh_tw2_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你在這裡`)
};

const zh_hk2_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你在這裡`)
};

const ur_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ یہاں ہیں`)
};

const fa_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شما اینجا هستید`)
};

const sw_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uko hapa`)
};

const nl_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bent hier`)
};

/**
* | output |
* | --- |
* | "You are here" |
*
* @param {BreadcrumbsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const breadcrumbs = /** @type {((inputs?: BreadcrumbsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BreadcrumbsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_breadcrumbs(inputs)
	if (locale === "ja") return ja_breadcrumbs(inputs)
	if (locale === "zh") return zh_breadcrumbs(inputs)
	if (locale === "es") return es_breadcrumbs(inputs)
	if (locale === "pt") return pt_breadcrumbs(inputs)
	if (locale === "id") return id_breadcrumbs(inputs)
	if (locale === "fr") return fr_breadcrumbs(inputs)
	if (locale === "tl") return tl_breadcrumbs(inputs)
	if (locale === "vi") return vi_breadcrumbs(inputs)
	if (locale === "ko") return ko_breadcrumbs(inputs)
	if (locale === "de") return de_breadcrumbs(inputs)
	if (locale === "ru") return ru_breadcrumbs(inputs)
	if (locale === "tr") return tr_breadcrumbs(inputs)
	if (locale === "it") return it_breadcrumbs(inputs)
	if (locale === "pl") return pl_breadcrumbs(inputs)
	if (locale === "uk") return uk_breadcrumbs(inputs)
	if (locale === "hi") return hi_breadcrumbs(inputs)
	if (locale === "ar") return ar_breadcrumbs(inputs)
	if (locale === "ms") return ms_breadcrumbs(inputs)
	if (locale === "bn") return bn_breadcrumbs(inputs)
	if (locale === "zh-TW") return zh_tw2_breadcrumbs(inputs)
	if (locale === "zh-HK") return zh_hk2_breadcrumbs(inputs)
	if (locale === "ur") return ur_breadcrumbs(inputs)
	if (locale === "fa") return fa_breadcrumbs(inputs)
	if (locale === "sw") return sw_breadcrumbs(inputs)
	if (locale === "nl") return nl_breadcrumbs(inputs)
	return en_breadcrumbs(inputs)
});